import { DateTime, DateTimeFormatOptions } from 'luxon';
import cc from 'classcat';

interface ICalendarMonthShifter {
    className?: string;
    currentDate: DateTime;
    previous: () => void;
    next: () => void;
    formatOptions: DateTimeFormatOptions;
}

const CalendarMonthShifter = ({ className, currentDate, previous, next, formatOptions }: ICalendarMonthShifter) => {
    return (
        <div className={cc(['calendar-month-shifter', className])}>
            <img className="calendar-month-shifter__arrow" src="/svg/arrow-left-blue-calendar.svg" alt="left arrow" onClick={() => previous()} />
            <h5 className="calendar-month-shifter__visible-period">{currentDate.toLocaleString(formatOptions)}</h5>
            <img className="calendar-month-shifter__arrow" src="/svg/arrow-right-blue-calendar.svg" alt="right arrow" onClick={() => next()} />
        </div>
    );
};

export default CalendarMonthShifter;
